import { FC, memo } from 'react';
import classNames from 'classnames';
import {useTranslation} from "react-i18next";
import { Typography, Button, Flex } from 'shared/_ui';

import cls from './PageError.module.scss';

interface PageErrorProps {
    className?: string;
}

export const PageError: FC<PageErrorProps> = memo(({ className }) => {
    const { t } = useTranslation();
    const reloadPage = () => {
        // eslint-disable-next-line no-restricted-globals
        location.reload();
    };

    return (
        <Flex
            max
            direction="column"
            align="center"
            justify="center"
            spacing={15}
            className={classNames(cls.PageError, className)}
        >
            <Typography.Text size={5}>{t('errorRequest')}</Typography.Text>
            <Button theme="background" onClick={reloadPage}>
                {t('reload')}
            </Button>
        </Flex>
    );
});
